// src/components/ChangeLogModal.js
import React from 'react';

// 📋 バージョン履歴のデータ
const changelogData = [
  {
    version: 'R3.0.9',
    date: '2026/10/12',
    title: 'レース一覧の表示改善 🏃‍♂️✨',
    details: [
      '【改善】レース一覧のリストを「国内」「海外」のセクションに分割しました。',
    ]
  },
  {
    version: 'R3.0.8',
    date: '2026/10/05',
    title: 'レース選択の初期表示を変更 🏃‍♂️✨',
    details: [
      '【改善】レース選択プリセットの初期表示を「本日以降に開催されるレース」に変更しました。本日以降の対象レースは最初から全件表示され、過去のレースは「続きを見る」ボタンで順次（6個ずつ）表示できるようにしました。',
    ]
  },
  {
    version: 'R3.0.7',
    date: '2026/10/02',
    title: '地図の距離表示の改善 🗺️✨',
    details: [
      '【改善】地図コンポーネント（GsiMap）の距離マーカー表示を改良し、ズームレベルに応じて広域では5km刻み、拡大時は1km刻みに自動で切り替わる動的表示を実装しました。',
    ]
  },  
  {
    version: 'レース追加',
    date: '2026/10/01',
    title: '10、11月開催のレースを追加！ 🏃🔥',
    details: [
      '10/04 トレニックワールド in おごせときがわ（51k・31k）',
      '10/11 日本山岳耐久レース（ハセツネCUP）（71.5k）',
      '10/11 OSJ KOUMI100 100マイル（165k）',
      '10/17 SADO ISLAND GOLD TRAIL（49k・29k）',
      '10/18 斑尾フォレストトレイル（50k・20k）',
      '10/24 上越妙高エクスプレストレイル（50k・35k・14k）',
      '10/25 宇都宮トレイルラン（36k・21k）',
      '10/30 LAKE BIWA（170k）',
      '11/07 信州松代ラウンドトレイル（36k・13k）',
      '11/07 Tokyo100 Endurance trail（101k）',
      '11/08 甲州アルプスオートルートチャレンジ（108k・70k・55k）',
      '11/14 FunTrails Round 秩父＆皆野（160k・105k・54k）'
    ]
  },  {
    version: 'R3.0.6',
    date: '2026/09/26',
    title: '3Dコースビュー関門時間の表示 🏔️✨',
    details: [
      '【追加】関門時間が設定されているエイドポイント到達時に一時停止し、関門時間をポップアップ表示する機能を追加しました。',
    ]
  },
  {
    version: 'R3.0.5',
    date: '2026/09/22',
    title: '3Dコースビューの表示スケール最適化 🏔️✨',
    details: [
      '【改善】コースの長さに応じて地形メッシュの広さとカメラの追従距離を動的に自動調整するようにし、長距離コースで地面が途切れてしまう不具合を解消しました。',
    ]
  },
  {
    version: 'R3.0.4',
    date: '2026/09/03',
    title: '主要大会リストの自動生成 🏔️📅',
    details: [
      '【自動生成】今月以降の主要トレラン大会リストを自動生成する仕組みを導入しました。',
    ]
  },
  {
      version: 'R3.0.3',
      date: '2026/08/30',
      title: '国内 / 海外レース区分の追加 🌏🇯🇵',
      details: [
        '【地域区分】プリセットレースに region（国内 / 海外）フィールドを追加しました。',
        '【フィルタ機能】レース一覧画面に「国内 / 海外 / 全て」のフィルタを追加し、レース選択がより簡単になりました。',
      ]
  },
  {
    version: 'レース追加',
    date: '2026/08/19',
    title: '９月開催のレースを追加！ 🏃🔥',
    details: [
      '9/22【信越五岳トレイルランニングレース】100mi・110k',
    ]
  },  
  {
    version: 'R3.0.2',
    date: '2026/08/03',
    title: 'ITRA Finisher Level 表示追加 🎖️✨',
    details: [
      '【FL表示】プリセットレースのカードに ITRA Finisher Level（FL）を表示するようにしました。これにより、各レースを完走するために必要な走力の目安が一目で分かるようになり、km-effort と合わせてより現実的な完走計画を立てやすくなりました。'
    ]
  },
  {
    version: 'レース追加',
    date: '2026/08/03',
    title: '９月開催のレースを追加！ 🏃🔥',
    details: [
      '9/27【筑波連山天空ロード&トレイルラン】70k・45k・25k',
      '9/23【OSJ ONTAKE50】ロング54k・ミドル30k',
      '9/12【上州武尊山スカイビュートレイル】HOTAKA138k・TONE77k',
      '9/07【白馬国際クラシック】50k・29k',
    ]
  },  
  {
    version: 'レース追加',
    date: '2026/07/26',
    title: '８月開催のレースを追加！ 🏃🔥',
    details: [
      '8/29【志賀高原100】100k・40k・18k',
      '8/08【Trans Japan Alps Race (TJAR)】',
      '8/02【OSJ Sapporo City Trail】50k・20k'
    ]
  },
  {
    version: 'R3.0.1',
    date: '2026/07/01',
    title: '高低グラフの横幅調整 📏✨',
    details: [
      '【グラフ横幅調整】高低グラフの横幅を累積距離に応じて動的に変更するようにしました。これにより、長距離レースでもグラフが圧縮されず、視認性が向上しました。'
    ]
  },
  {
    version: 'R3.0.0',
    date: '2026/06/26',
    title: '3D表示機能の追加 🏔️✨',
    details: [
      '【3D表示】GPXデータから生成したコースを立体表示し、高低差を直感的に確認できるようにしました。標高データをもとに地形を3D化し、コース全体のアップダウンを視覚的に把握できます。',
    ]
  },
  {
    version: 'R2.4.2',
    date: '2026/06/20',
    title: 'ResultTable のモバイル最適化と操作性改善 📱✨',
    details: [
      '【モバイル最適化】スマホ利用時、シミュレーション結果の表示は表⇒カード型とし、視認性を改善しました。',
      '【操作性改善】「保存データクリア」実行時に確認ダイアログを追加し、誤操作によるデータ消去を防止しました。',
      '【レース選択UI改善】レース一覧を「続きを見る」形式に変更し、読み込み速度と操作性を向上しました。',
      '【ソート機能追加】レース一覧に「日付順／km-effort順」のソート機能を追加しました。'
    ]
  },
  {
    version: 'R2.4.1',
    date: '2026/06/16',
    title: '地図レイヤーの改善とUI調整 🗺️✨',
    details: [
      '【航空写真追加】ESRI World Imagery（航空写真）をレイヤーとして追加しました。',
    ]
  },
  {
    version: 'レース追加',
    date: '2026/06/17',
    title: '７月開催のレースを追加！ 🏔️🔥',
    details: [
      '7/26【大雪山トレイルジャーニー】60k・40k・15k',
      '7/18【OSJ ONTAKE100】100mi・100k',
      '7/19【野沢温泉トレイルランニングレース】65k・37k・14k',
      '7/19【霧島・えびの高原エクストリームトレイル】62k・34k',
      '7/04【中央アルプス スカイラインジャパン】90k・38k・20k',
      '7/04【ロッキンベア妙高】48k・17k',
      '7/04【南阿蘇カルデラトレイル】50k・32k・18k'
    ]
  },
  {
    version: 'R2.4.0',
    date: '2026/06/15',
    title: 'トレイル向けペース補正モデルの最適化 🏔️⚙️',
    details: [
      'シミュレーション結果が速めに出てしまう問題を解消するため、トレイル特有のペース補正モデルを全面的に見直しました。',
      '【上り補正改善】上り補正を強化し、5〜20%の上りでの遅延をより現実的に反映しました。',
      '【下り補正改善】トレイル特有の下りでの減速を正確に表現できるようにしました。',
      '【補正上限の調整】トレイルの歩き区間に対応。'
    ]
  },
  {
    version: 'R2.3.0',
    date: '2026/06/11',
    title: 'UI改善＆データ管理機能追加 🧑‍🎨🗂️',
    details: [
      '【ナビゲーション改善】チップ型ナビを導入し、操作性を改善しました。',
      '【データ管理改善】レースごとの保存データを削除できる「保存データクリア」ボタンを追加し、不要なエイド情報を簡単にリセットできるようにしました。',
      '【地図表示改善】コース上に距離ラベルを追加し、距離を把握しやすくしました。'
    ]
  },
  {
    version: 'R2.2.6',
    date: '2026/06/02',
    title: '軽微な機能改善',
    details: [
      '【UI視認性向上】シミュレーション結果にレースの制限時間を表示するようにしました。'
    ]
  },
  {
    version: 'R2.2.4',
    date: '2026/05/29',
    title: '軽微な機能改善',
    details: [
      '【レース選択】選択するレースをkm-effort に基づくカテゴリ（超初級〜超ウルトラ）で分類しました。',
    ]
  },
  {
    version: 'R2.2.3',
    date: '2026/05/27',
    title: '軽微な修正・機能改善',
    details: [
      '【グラフ機能】FINISH地点のツールチップに制限時間を表示するようにしました。',
      '【グラフ機能】ツールチップを半透明背景＋文字を大きくして見やすくしました。',
      '【地図機能】FiNISH地点のツールチップに制限時間を表示するようにしました。',
    ]
  },
  {
    version: 'レース追加',
    date: '2026/05/27',
    title: 'リクエスト対応：「中央アルプス スカイラインジャパン」を追加！ 🌲⛰️',
    details: [
      'リクエストいただいた絶景とテクニカルな稜線が魅力の「中央アルプス スカイラインジャパン」の3レース（90k・38k・20k）を追加しました！',
    ]
  },  
  {
    version: 'R2.2.2',
    date: '2026/05/25',
    title: '軽微な修正・機能改善',
    details: [
      '【グラフ機能】グラフ右側の標高軸について、目盛りの重複表示を解消しました。',
      '【グラフ機能】エイドクリック時の反応を改善しました。',
      '【地図機能】地図上のエイドにも休憩時間を表示するようにしました（例：13:10（25分））。',
      '【UI視認性向上】レース選択後、シミュレーション情報入力エリアにスクロールするようにしました。'
    ]
  },
  {
    version: 'R2.2.1',
    date: '2026/05/24',
    title: '休憩時間の入力改善＆予想時間を到着時刻ベースへ変更 ⏱️🌙',
    details: [
      '【UI視認性向上】エイド情報入力の「休憩（分）」を、キーボード入力から5分刻みの選択式（ドロップダウン）に変更しました。',
      '【UI視認性向上】休憩時間の表記を到着時間の後ろに「青色（太字）」で表示しました。',
      '【シミュレーション改善】結果テーブルの予想時間を「出発時刻」から、ランナーが最も直感的に把握できる純粋な「到着時刻」ベースの計算ロジックに修正しました。'
    ]
  },
  {
    version: 'レース追加',
    date: '2026/05/20',
    title: '５月・６月開催のレースを追加！ 🌲⛰️',
    details: [
      '5/30開催   【奥武蔵ロングトレイル】105k 35k',
      '5/29開催   【丹波100アドベンチャートレイル】100mi 50k 20k',
      '6/5開催    【奥信濃100】100k 50k 25k',
      '6/20開催   【KAGASPA】100k・50k・20k ※予測タイムがかなり速めに出ますのでご注意ください',
      '6/26開催   【DEEP JAPAN ULTRA 100】160k・80k・30k'
    ]
  },
  {
    version: 'R2.2.0',
    date: '2026/05/16',
    title: '地図（国土地理院＆OpenTopoMap）表示機能を追加 🧭🗺️',
    details: [
      'リザルトテーブル下部に、国内・海外の両対応となる地図表示を追加しました。',
      'デフォルトの「国土地理院地図（国内専用）」に加え、海外レース向けに「OpenTopoMap（世界対応）」に切り替えも可能です。',
      '地図上にはGPSの走行軌跡（青い線＋進行方向の矢印）を描画し、エイド位置にピンを配置しました。',
      '各ピンの上には文字バッジ（START, A1, CP等）を表示し、クリックで予測通過時刻や予想気温のポップアップが確認できます。'
    ]
  },
  {
    version: 'レース追加',
    date: '2026/05/14',
    title: 'リクエスト対応：「DEEP JAPAN ULTRA 100」を追加！ 🌲⛰️',
    details: [
      'リクエストいただいた大自然の難関レース「DEEP JAPAN ULTRA 100」の3レース（160k・80k・30k）を追加しました！'
    ]
  },
  {
    version: 'R2.1.0',
    date: '2026/05/1',
    title: 'UI変更',
    details: [
      'レース選択のUIをドロップダウンからカード型に変更し、各レースの特徴が一目でわかるようになりました。',
      'レース開始時間、制限時間を自動入力するプリセット機能を追加しました。',
      'ITRA PI、会話ができるペースのUIを変更しました。'
    ]
  },
];

function ChangeLogModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h3  style={styles.headerTitle}>🆙 アップデート情報・更新履歴</h3>
          <button style={styles.closeButton} onClick={onClose}>&times;</button>
        </div>
        
        <div style={styles.content}>
          {changelogData.map((item, index) => (
            <div key={index} style={styles.logItem}>
              {/* バージョンと日付のバッジエリア */}
              <div style={styles.meta}>
                <span style={styles.version}>{item.version}</span>
                <span style={styles.date}>{item.date}</span>
              </div>
              
              {/* アップデートのタイトル */}
              <h4 style={styles.logTitle}>{item.title}</h4>
              
              {/* 詳細リスト（ここを綺麗な左寄せ＆箇条書きに） */}
              <ul style={styles.detailsList}>
                {item.details.map((detail, idx) => (
                  <li key={idx} style={styles.detailText}>{detail}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// 🎨 スタイル調整
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
    padding: '16px'
  },
  modal: {
    backgroundColor: '#ffffff',
    width: '100%',
    maxWidth: '550px',
    maxHeight: '80vh',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  header: {
    padding: '16px 20px',
    borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff3e6'
  },
  headerTitle: {
    margin: 0,
    fontSize: '1.1rem',
    color: '#ff6600',
    fontWeight: 'bold'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#999',
    padding: '0 4px'
  },
  content: {
    padding: '20px',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
    textAlign: 'left' // 💡 親要素で全体を左寄せに明示
  },
  logItem: {
    marginBottom: '20px',
    backgroundColor: '#ffffff',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #eef0f2',
    textAlign: 'left' // 💡 各ログ内も確実に左寄せ
  },
  meta: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    marginBottom: '8px',
    justifyContent: 'flex-start' // 💡 バッジ群も左側に整列
  },
  version: {
    backgroundColor: '#ff6600',
    color: '#ffffff',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    padding: '2px 6px',
    borderRadius: '4px'
  },
  date: {
    fontSize: '0.8rem',
    color: '#888'
  },
  logTitle: {
    margin: '4px 0 10px 0',
    fontSize: '0.95rem',
    color: '#333',
    fontWeight: 'bold',
    textAlign: 'left'
  },
  detailsList: {
    margin: 0,
    paddingLeft: '20px', // 💡 箇条書きの「・」が綺麗に入るように余白を確保
    color: '#555',
    textAlign: 'left'
  },
  detailText: {
    fontSize: '0.85rem',
    lineHeight: '1.6',
    marginBottom: '6px',
    listStyleType: 'disc' // 💡 確実に見やすい黒丸の箇条書きにする
  }
};

export default ChangeLogModal;